const parseBoolean = str => str === 'true';

export default parseBoolean;
